import {getArgs} from './args.js';
import {publishPlanarBounce} from 'messaging/messages.js';
import {density} from './operations.js';
import {doc} from './documentation.js';
import {reset} from './time.js';
import {getSlicedParameters, sliceParams} from './params.js';
import {lazy} from './lazy.js';
import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
// given a vector-field equation which 

const SCALE = 1;
// p = (x,y) => xy
// q = (x,y) => y^2-x^2
doc(
    "vectorField",
    {
        "x-function": "(x,y) => x*y",
        "y-function": "(x,y) => y*y-x*x",
        "boundary-function": "",
    },
    "Runs the x and y component functions on every parameter, to generate the new position. " + 
        "Ex: vectorField((x,y) => x*y, (x,y) => y*y-x*x, reset())"
);
export const vectorField = (p, q, boundsFunc=reset(true)) => {
    let slicer = sliceParams();
    return (... args) => {
        let {coords, history, speed} = getArgs(args);
        coords = getSlicedParameters(slicer, coords, args.slice(1));
        let scaling = 10;
        let sc = speed / 80;
        let getDensity = density(args.slice(1));

        // for each coordinate evaluate the p
        // and q functions at that point to
        // get the new point. Then check if it crosses
        // the boundary. If so start over
        let _coords = {};
        let _outOfBounds = {};
        for (let id in coords) {
            let {x,y} = coords[id];
            let _density = getDensity(x,y, coords[id]);
            let _scaling  = scaling;
            let coord = scale(translate([x,y], -WIDTH/2, -HEIGHT/2), 1/_scaling);
            let evaled = evalVector(p,q,coord);
            let added = vectorAdd(evaled, coord);
            let newCoord = translate(scale(added, _scaling), WIDTH/2, HEIGHT/2);
            let adjusted = vectorAdd([x,y], scale(vectorDiff(newCoord, [x,y]), sc/_density));
            
            newCoord=adjusted;
            // given the direction we can calculate where we wanna go
            if (isOutOfBounds(newCoord)) {
                // if out of bounds just return to start
                _outOfBounds[id] = {
                    x: newCoord[0],
                    y: newCoord[1]
                };
            } else {
                _coords[id] = {
                    x: newCoord[0],
                    y: newCoord[1],
                    density: _density
                };
            }
        }
        
        if (Object.keys(_outOfBounds).length > 0) {
            publishPlanarBounce(true);
        }
        return {
            ..._coords,
            ...boundsFunc(_outOfBounds, ...args.slice(1))
        };
    };
};

const translate = (vector, x, y) =>
      vectorAdd(vector, [x,y]);

const scale = (vector, scaling) =>
      scalarMult(scaling, vector);

const isOutOfBounds = ([x,y]) =>
      x <= PADDING || x >= WIDTH - PADDING ||
      y <= PADDING || y >= HEIGHT - PADDING;

const vectorAdd = (a,b) => 
      a.map((q, i) => q + b[i]);

const scalarMult = (s,v) =>
    v.map(t => t*s);

// a-b in vectors
const vectorDiff = (a,b) => 
    a.map((t, i) => t - b[i]);

const evalVector = (p,q,[x,y]) => ([
    p(x,y),
    q(x,y)
]);
